import React from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper
} from '@mui/material';
import { TranslatedText } from '@ianesthesie-kit/core';
import {
  DialogPayload,
  DialogSecondaryAction,
  useDialogPromise
} from '@ianesthesie-kit/redux';

export const ConfirmationPromiseDialog = (props: DialogPayload) => {
  const { closeAndResolve } = useDialogPromise();
  return (
    <Paper sx={{ p: 0, maxWidth: 425 }}>
      {props.title && (
        <DialogTitle>
          <TranslatedText id={props.title} />
        </DialogTitle>
      )}
      <DialogContent>
        <DialogContentText whiteSpace="pre-wrap">
          {props.message && <TranslatedText id={props.message} />}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <DialogSecondaryAction onClick={() => closeAndResolve(false)}>
          <TranslatedText id="app.cancel" />
        </DialogSecondaryAction>
        <Button onClick={() => closeAndResolve(true)}>
          <TranslatedText id="app.ok" />
        </Button>
      </DialogActions>
    </Paper>
  );
};
